import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox } from '../../../../../shared';
import BaseSection from './BaseSection';
import { Box } from '@mui/material';

const DayRosterSection = ({ excludingCredit = true, sentToAgency = false }) => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  return (
    <>
      <BaseSection hasEmployee={true} />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <ControlledCheckbox
          control={control}
          name="inc_notes"
          label={t('includingNotes')}
        />
        {excludingCredit && (
          <ControlledCheckbox
            control={control}
            name="exc_credit"
            label={t('excludingCredit')}
          />
        )}
        {sentToAgency && (
          <ControlledCheckbox
            control={control}
            name="sent_agn_flag"
            label={t('sentToAgency')}
          />
        )}
      </Box>
    </>
  );
};

export default DayRosterSection;
